import CityPageTemplate from "../city-template/CityPageTemplate";
import { bereaConfig } from "./data";

export default function BereaPage() {
  return <CityPageTemplate config={bereaConfig} />;
}